import { render, staticRenderFns } from "./ContactPersonDetails.vue?vue&type=template&id=284f7309"
import script from "./ContactPersonDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPersonDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports